//@flow
import type {AdminAddress} from '../../../entities/logistic';

export type Admin1 = {
  admin1Id: number,
  admin1Name: string,
  type: 'admin1',
};

export type Admin2 = {
  admin2Id: number,
  admin2Name: string,
  type: 'admin2',
};

export type Admin3 = {
  admin3Id: number,
  admin3Name: string,
  type: 'admin3',
};

export function adminResponseToAdminAddress(
  admin: Admin1 | Admin2 | Admin3
): AdminAddress {
  if (admin.type === 'admin1') {
    return {
      adminId: admin.admin1Id.toString(),
      adminName: admin.admin1Name,
      type: admin.type,
    };
  }

  if (admin.type === 'admin2') {
    return {
      adminId: admin.admin2Id.toString(),
      adminName: admin.admin2Name,
      type: admin.type,
    };
  }

  return {
    adminId: admin.admin3Id.toString(),
    adminName: admin.admin3Name,
    type: admin.type,
  };
}
